/**
 * Markup names produced by the annotation tools (cloud, arrow, line, text, freeline).
 * Used to distinguish user-created annotations from measurement markups.
 */
export const ANNOTATION_MARKUP_NAMES: ReadonlySet<string> = new Set([
  'cloudMarkup',
  'arrowMarkup',
  'lineMarkup',
  'textMarkup',
  'freelineMarkup',
]);
